import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, StateConfig, StateTransferType } from '@spartacus/core';
import { CATALOG_FEATURE } from './catalog-state';
import { reducerProvider, reducerToken } from './reducers';

function catalogStoreConfigFactory(): StateConfig {
  return {
    state: {
      ssrTransfer: {
        keys: { [CATALOG_FEATURE]: StateTransferType.TRANSFER_STATE },
      },
    },
  };
}

@NgModule({
  imports: [
    StoreModule.forFeature(CATALOG_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(catalogStoreConfigFactory),
  ],
  providers: [reducerProvider],
})
export class CatalogStoreModule {}
